var _defs, _linearGradient;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatasetArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 37.581,
    y1: 25.944,
    x2: 33.5,
    x1: 33.5,
    id: "b",
    gradientTransform: "translate(-9.533 .108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4b4b4b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b3b3b",
    offset: 1
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 24,
    y1: 24,
    x2: 39,
    x1: 9,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fede00",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd000",
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffca28",
      fillOpacity: 1
    },
    d: "M39 41a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h26a2 2 0 0 1 2 2v34z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#b)"
    },
    d: "M26.595 26.956a.995.995 0 0 0-.989-.848h-3.279a.995.995 0 0 0-.988.848c-.269 1.802-.872 5.913-.872 6.652a3.5 3.5 0 1 0 7 0c0-.739-.603-4.85-.872-6.652zm-2.628 8.152a1.5 1.5 0 1 1 .001-3 1.5 1.5 0 0 1 0 3z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 1.16547
    },
    d: "m26.848 7.32.006 1.253c.002.346-.24.628-.539.629l-1.626.007c-.598.002-1.087-.557-1.09-1.249-.004-.691.48-1.255 1.078-1.257l1.626-.007c.3-.002.543.278.545.624zm-2.153 3.142c-.003-.692-.492-1.251-1.09-1.249l-1.626.007c-.3.002-.54.283-.54.63l.007 1.252c.002.346.246.626.545.624l1.626-.007c.598-.002 1.081-.566 1.078-1.257zm-1.072 2.51c.004.692.492 1.251 1.09 1.249l1.626-.007c.3-.001.54-.283.54-.629l-.007-1.253c-.001-.346-.246-.625-.545-.624l-1.626.007c-.598.002-1.081.566-1.078 1.257zm1.096 2.502c-.003-.692-.491-1.251-1.09-1.248l-1.626.006c-.3.002-.54.283-.539.63l.006 1.252c.002.346.246.626.545.624l1.626-.006c.599-.003 1.082-.566 1.078-1.258zm-1.072 2.51c.004.692.492 1.252 1.09 1.249l1.626-.007c.3-.001.541-.283.54-.629l-.007-1.253c-.001-.346-.245-.625-.545-.624l-1.626.007c-.598.002-1.081.566-1.078 1.258zm.025 5.013c.003.691.491 1.25 1.09 1.248l1.626-.007c.299-.001.54-.283.539-.629l-.006-1.253c-.002-.345-.246-.625-.545-.624l-1.626.007c-.599.003-1.082.566-1.078 1.258zm1.072-2.51c-.004-.693-.492-1.252-1.09-1.25l-1.627.008c-.299 0-.54.283-.539.628l.006 1.253c.002.346.246.626.546.625l1.626-.007c.598-.003 1.08-.566 1.078-1.258z",
    fill: "#c28200"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetArchive);
export default __webpack_public_path__ + "static/media/datasetArchive.7368fe76926491312d9892bf533c0c61.svg";
export { ForwardRef as ReactComponent };